// extracted by mini-css-extract-plugin
export default {"grid":"grid_grid__aQIka"};